import { styled } from "@mui/material/styles";
import { Card, Tabs, Tab, Badge } from "@mui/material";
import { useColors } from "../../../Context/ColorsContext";

export const SectionPageTitle = styled('section')(() => ({
    display:'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width:'100%',
    gap: 16
}))

export const CustomCard = styled(Card)(({theme}) => ({
    height: '100%',
    width: '100%',
    borderRadius: 10,
    boxShadow: 'rgb(61 71 82 / 20%) 0px 4px 8px',
    padding: 0,
    overflow: 'auto',
    marginTop: '10px !important',
      '&::-webkit-scrollbar': {
        width: 5,
        height: 5
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '0px !important',
    }
}))

export const CustomTabs = styled(Tabs)(({theme}) => {
  const { colors } = useColors();
  return {
    backgroundColor: '#fff',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottom: '1px solid #e0e0e0',
    padding: '6px 4px',
    minHeight: 'auto',
    boxShadow: 'none',
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    '& .MuiButtonBase-root.MuiTab-root': {
      textTransform: 'none',
      margin: '0 4px',
      minHeight: '30px',
      zIndex: 1,
      opacity: 1,
      color: '#68798f',
      padding: '5px 13px !important',
      fontWeight: 500,
      whiteSpace: 'nowrap',
      borderRadius: '8px',
      fontSize: '14px',
    },
    '& .MuiTabs-flexContainer > button + button': {
      borderLeft: '1px solid #efefef',
      borderRadius: '0px !important',
    },
    '& .MuiButtonBase-root.MuiTab-root.Mui-selected': {
      backgroundColor: `${colors.sidebarSelectColor} !important`,
      color: '#fff !important',
      borderLeft: '1px solid transparent',
      borderRadius: '8px !important',
    },
    '& .MuiButtonBase-root.MuiTab-root.Mui-selected .MuiBadge-badge': {
      backgroundColor: colors.navbarColor,
      border: `1px solid ${colors.navbarColor}`,
      color: '#fff',
    },
    '& .MuiTabs-scrollButtons.Mui-disabled': {
      opacity: 0,
      width: 0,
      minWidth: 0,
      padding: 0,
      margin: 0,
      overflow: "hidden",
    },
    [theme.breakpoints.down('md')]: {
      '& .MuiButtonBase-root.MuiTab-root': {
        fontSize: '12px'
      }
    },
  }
})

export const ItemTab = styled(Tab)(() => {
    return {
    }
})

export const ContainerContent = styled('div')(({ theme }) => {
    return {
        display: 'flex',
        flexDirection: 'row',
        marginTop: '10px',
        width: '100%',
        gap: '0.75rem',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column'
        },
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column'
        }
    }
})

export const ContainerLeft = styled('div')(({ theme }) => {
    return {
        display: 'flex',
        width: '73%',
        gap: '0.70rem',
        flexDirection: 'column',
        [theme.breakpoints.up('lg')]: {
            width: '70%',
        },
        [theme.breakpoints.down('md')]: {
            width: '100%',
            flexDirection: 'column'
        },
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            width: '100%',
        }
    }
})

export const ContainerRight = styled('div')(({ theme }) => {
    return {
        width: '27%',
        height: '100%',
        [theme.breakpoints.up('lg')]: {
           width: '30%',
        },
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        }
    }
})

export const CustomBadge = styled(Badge)(() => {
  return {
    marginTop: 0,
    marginRight: 15,
    position: 'relative',
    '& .MuiBadge-badge': {
      backgroundColor: '#b7cbe4',
      color: '#68798f',
      top: '50%',
      right: '-12px',
      transform: 'translateY(-50%)',
      fontSize: '0.8rem',
      fontWeight: 600,
      border: '1px solid #b7cbe4',
    }
  }
});

export const DetailInfo = styled('div')(() => {
    return {
        width: '100%',
    }
})
